import { Icon } from 'antd';
import { isUrl } from '../utils/utils';

const RobotSvg = () => (
  <svg width="1.05em" height="1.05em" stroke="currentColor" viewBox="0 0 18 16" strokeWidth="0.7" fill="currentColor">
    <path
      d="M15.3142857,9.20294927 L14.5142857,9.20294927 C14.5142857,7.096927 13.6,5.57591091 12.2285714,4.63990102 L13.7142857,1.36386637 C14.0571429,1.36386637 14.2857143,1.1298639 14.2857143,0.778860184 C14.2857143,0.544857709 14.1714286,0.193853997 13.9428571,0.0768527599 C13.7142857,-0.0401484774 13.3714286,-0.0401484774 13.1428571,0.193853997 C12.9142857,0.427856472 12.9142857,0.778860184 13.1428571,1.01286266 L11.5428571,4.2888973 C10.4,3.82089235 9.14285714,3.46988864 7.88571429,3.58688988 C6.62857143,3.58688988 5.37142857,3.82089235 4.22857143,4.40589854 L2.74285714,1.1298639 C2.85714286,0.895861421 2.85714286,0.544857709 2.74285714,0.310855235 C2.51428571,0.0768527599 2.17142857,0.0768527599 1.94285714,0.193853997 C1.6,0.310855235 1.48571429,0.544857709 1.6,0.895861421 C1.6,1.1298639 1.82857143,1.36386637 2.17142857,1.36386637 L3.77142857,4.63990102 C2.4,5.57591091 1.48571429,7.096927 1.48571429,9.20294927 L0.685714286,9.20294927 C0.571428571,9.20294927 0.342857143,9.31995051 0.228571429,9.43695174 C0.114285714,9.55395298 0,9.78795546 0,9.90495669 L0,11.542974 C0,11.6599753 0.114285714,11.8939777 0.228571429,12.010979 C0.342857143,12.1279802 0.457142857,12.2449814 0.685714286,12.2449814 L1.48571429,12.2449814 L1.48571429,13.0639901 C1.48571429,13.6489963 1.94285714,14 2.4,14 L13.6,14 C14.1714286,14 14.5142857,13.5319951 14.5142857,13.0639901 L14.5142857,12.2449814 L15.3142857,12.2449814 C15.6571429,12.2449814 16,11.8939777 16,11.542974 L16,9.90495669 C16,9.67095422 15.8857143,9.55395298 15.7714286,9.43695174 C15.6571429,9.31995051 15.5428571,9.20294927 15.3142857,9.20294927 Z M1.25714286,11.542974 L0.571428571,11.542974 L0.571428571,9.90495669 L1.25714286,9.90495669 L1.25714286,11.542974 Z M13.9428571,12.9469889 C13.9428571,13.1809913 13.8285714,13.2979926 13.6,13.2979926 L2.4,13.2979926 C2.17142857,13.2979926 2.05714286,13.1809913 2.05714286,12.9469889 L2.05714286,9.43695174 C2.05714286,4.87390349 6.17142857,4.40589854 8,4.2888973 C9.82857143,4.17189607 13.9428571,4.75690225 13.9428571,9.31995051 L13.9428571,12.9469889 Z M15.3142857,11.542974 L14.6285714,11.542974 L14.6285714,9.90495669 L15.3142857,9.90495669 L15.3142857,11.542974 Z"
      id="Shape"
    />
    <path
      d="M5.64859684,8 C4.87925165,8 4,8.37554932 4,9.34482759 C4,9.75862069 4.10990646,10.1724138 4.43962582,10.4827586 C4.76934519,10.7931034 5.09906456,11 5.53869038,11 L10.3745744,11 C11.1439196,11 12,10.3657227 12,9.5 C12,8.40631104 10.9241067,8 10.4844809,8 L5.64859684,8 Z M5.77645765,10.3915039 C5.55956088,10.3915039 4.73859083,10.2000779 4.73859083,9.51219356 C4.73859083,8.75841527 5.52565957,8.63288322 5.65670883,8.63288322 L10.2269389,8.63288322 C10.4571658,8.63288322 11.2312323,8.77925268 11.2312323,9.51219356 C11.2312323,10.1513718 10.533264,10.3915039 10.3466877,10.3915039 L5.77645765,10.3915039 Z"
      id="Shape"
    />
  </svg>
);

const RobotIcon = (props) => <Icon component={RobotSvg} {...props} />;

function formatter(data, parentPath = '/', parentAuthority) {
  return data.map((item) => {
    let { path } = item;
    if (!isUrl(path)) {
      path = parentPath + item.path;
    }
    const result = {
      ...item,
      path,
      authority: item.authority || parentAuthority,
    };
    if (item.children) {
      result.children = formatter(item.children, `${parentPath}${item.path}/`, item.authority);
    }
    return result;
  });
}

function isIOS() {
  const u = navigator.userAgent;
  const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; // android终端
  const iosOrAndroid = isiOS || isAndroid;
  return iosOrAndroid;
}

function createMenuData() {
  const array = [
    {
      name: i('机器人'),
      icon: <RobotIcon />,
      path: '/robot',
      permissionCode: 'Robot',
      children: [
        {
          name: i('机器人管理'),
          path: '/manager',
          permissionCode: 'Robot.Manager',
        },
        //2023-12-13 功能下架暂不删除，删除时间待定
        // {
        //   name: i('机器人注册'),
        //   path: '/factory',
        //   permissionCode: 'Robot.Factory',
        // },
        {
          name: i('任务管理'),
          path: '/task',
          permissionCode: 'Robot.Task',
        },
        {
          name: i('记录分享历史'),
          path: '/shared-record-history',
          permissionCode: 'Robot.Manager',
        },
        {
          name: i('远程控制日志'),
          path: '/remote-control-log',
          permissionCode: 'Robot.RemoteControl',
        },
        // {
        //   name: i('机器人注册-补充信息'),
        //   path: '/additional-info',
        //   permissionCode: 'Robot.RegisterAddition',
        // },
      ],
    },
    // {
    //   name: i('数据回流'),
    //   icon: <Icon type="cloud-upload" />,
    //   path: '/dataReflux',
    //   permissionCode: 'DataReflux',
    //   children: [
    //     {
    //       name: i('数据回流计划'),
    //       path: '/dataRefluxPlan',
    //       permissionCode: 'DataReflux.DataRefluxPlan',
    //     },
    //   ],
    // },
    // {
    //   name: i('设备档案管理'),
    //   icon: <Icon type="file-done" />,
    //   path: '/equipmentManagement',
    //   permissionCode: 'ArchiveManagement',
    //   children: [
    //     {
    //       name: i("机器人设备档案管理"),
    //       path: "/robotProfile",
    //       permissionCode: "ArchiveManagement.Robot",
    //     },
    //     {
    //       name: i("事件分析(工厂)"),
    //       path: "/eventAnalysis",
    //       permissionCode: "ArchiveManagement.EventAnalysis",
    //     },
    //     {
    //       name: i("机器人出厂默认配置"),
    //       path: "/defaultConfig",
    //       permissionCode: "ArchiveManagement.DefaultConfig",
    //     },
    //   ]
    // },
    // {
    //   name: i('远程运维'),
    //   icon: 'tool',
    //   path: '/remote-maintenance',
    //   permissionCode: 'RemoteMaintenance',
    //   children: [
    //     {
    //       name: i("远程运维工作台"),
    //       path: "/remoteOperator-workbench",
    //       permissionCode: "RemoteMaintenance.RemoteOperator.List",
    //     },
    //     {
    //       name: i("工作台配置"),
    //       path: "/workbench-config",
    //       permissionCode: "RemoteMaintenance.Workbench.Config",
    //     },
    //     {
    //       name: i("客户组配置"),
    //       path: "/group-set",
    //       permissionCode: "RemoteMaintenance.Group.Set",
    //     },
    //     {
    //       name: i("人员分组配置"),
    //       path: "/person-group-set",
    //       permissionCode: "RemoteMaintenance.Person.Group.Set",
    //     },
    //     {
    //       name: i("分单管理"),
    //       path: "/dispatch-event-ticket-manager",
    //       permissionCode: "RemoteMaintenance.DispatchEventTicketManager",
    //     },
    //   ],
    // },
    {
      name: i('事件中心'),
      icon: 'snippets',
      path: '/event',
      permissionCode: 'EventCenter',
      children: [
        {
          name: i('事件定义'),
          path: '/definition',
          permissionCode: 'EventCenter.Definition',
        },
        {
          name: i('事件多语言管理'),
          path: '/multi-language',
          permissionCode: 'EventCenter.MultilingualManager',
        },
        {
          name: i('通知模板配置'),
          path: '/send-template',
          permissionCode: 'EventCenter.SendTemplateConfig',
        },
        {
          name: i('租户消息配置'),
          path: '/tenant-message-config',
          permissionCode: 'EventCenter.TenantMessageConfig',
        },
        {
          name: i('用户消息配置'),
          path: '/user-message-config',
          permissionCode: 'EventCenter.UserMessageConfig.List',
        },
        {
          name: i('事件订阅'),
          path: '/template-content/eventSubscribe/viewSubscribe',
          permissionCode: 'EventCenter.EventSubscribe.List',
        },
        {
          name: i('事件分析'),
          path: '/event-analysis',
          permissionCode: 'EventCenter.Analysis',
        },
        // 2024-01-25功能下架，删除时间待定
        // {
        //   name: i('事件管理'),
        //   path: '/event-manager',
        //   permissionCode: 'EventCenter.Manager.List',
        // },
        {
          name: i('Jira记录'),
          path: '/jira-record',
          permissionCode: 'EventCenter.JiraRecord',
        }
      ],
    },
    // {
    //   name: i('客服中心'),
    //   icon: 'customer-service',
    //   path: '/customerService',
    //   permissionCode: 'CustomerAssist',
    //   children: [
    //     {
    //       name: i('报修管理'),
    //       path: '/repair-management',
    //       permissionCode: 'CustomerAssist.RepairManager.List',
    //     },
    //     {
    //       name: i('客户信息'),
    //       path: '/customer-information',
    //       permissionCode: 'CustomerAssist.CustomerInformation.List',
    //     }
    //   ],
    // },
    // {
    //   name: i("任务中心"),
    //   icon: 'pushpin',
    //   path: "/task-center",
    //   permissionCode: "Task",
    //   key: "task-center",
    //   children: [
    //     {
    //       name: i("任务管理"),
    //       path: "/task-manager",
    //       key: "task-manager",
    //       permissionCode: "Task.TaskManager",
    //     },
    //     {
    //       name: i("生成规则管理"),
    //       path: "/rule-manager",
    //       key: "rule-manager",
    //       permissionCode: "Task.RuleManager",
    //     },
    //     {
    //       name: i("关闭任务管理"),
    //       path: "/close-task-manager",
    //       key: "close-task-manager",
    //       permissionCode: "Task.CloseTaskManager",
    //     },
    //     {
    //       name: i("关闭规则管理"),
    //       path: "/close-rule-manager",
    //       key: "close-rule-manager",
    //       permissionCode: "Task.CloseRuleManager",
    //     },
    //     {
    //       name: i("客户组配置"),
    //       path: "/customerGroup-config",
    //       key: "customerGroup-config",
    //       permissionCode: "Task.CustomerGroupConfig",
    //     },
    //     {
    //       name: i("任务标签配置"),
    //       path: "/task-label-config",
    //       key: "task-label-config",
    //       permissionCode: "Task.TaskLabelConfig",
    //     },
    //   ],
    // },
    // {
    //   name: i("工单中心"),
    //   icon: 'book',
    //   path: "/udesk-center",
    //   permissionCode: "Udesk",
    //   key: "udesk-center",
    //   children: [
    //     {
    //       name: i("工单管理"),
    //       path: "/udesk-manager",
    //       key: "udesk-manager",
    //       permissionCode: "Udesk.Manager",
    //     },
    //     //2023-12-13 功能下架暂不删除，删除时间待定
    //     // {
    //     //   name: i("工单类型模版"),
    //     //   path: "/udeskType-template",
    //     //   key: "udeskType-template",
    //     //   permissionCode: "Udesk.UdeskTypeTemplate",
    //     // },
    //     // {
    //     //   name: i("内容模版"),
    //     //   path: "/contentTemplateList",
    //     //   key: "contentTemplateList",
    //     //   permissionCode: "Udesk.ContentTemplate",
    //     // },
    //     {
    //       name: i("工单分派"),
    //       path: "/dispatch",
    //       key: "dispatch",
    //       permissionCode: "Udesk.Dispatch",
    //     },
    //     {
    //       name: i("Jira流转配置"),
    //       path: "/jiraTransferConfig",
    //       key: "jiraTransferConfig",
    //       permissionCode: "Udesk.JiraTransferConfig",
    //     }
    //   ],
    // },
    // {
    //   name: i("规则中心"),
    //   icon: 'calendar',
    //   path: "/rule-center",
    //   permissionCode: "Rule",
    //   key: "rule-center",
    //   children: [
    //     //2023-12-13 功能下架暂不删除，删除时间待定
    //     // {
    //     //   name: i("工单规则池"),
    //     //   path: "/udeskRule-pool-list",
    //     //   key: "udeskRule-pool-list",
    //     //   permissionCode: "Rule.UdeskRulePool",
    //     // },
    //     // {
    //     //   name: i("执行对象组管理"),
    //     //   path: "/executionObjectGroup-manager",
    //     //   key: "executionObjectGroup-manager",
    //     //   permissionCode: "Rule.ExecutionObjectGroupManager",
    //     // },

    //     // {
    //     //   name: i("生成规则管理"),
    //     //   path: "/GenerateRules-manager",
    //     //   key: "GenerateRules-manager",
    //     //   permissionCode: "Rule.GenerateRulesManager",
    //     // },
    //     {
    //       name: i("事件组管理"),
    //       path: "/incidentGroup-manager",
    //       key: "incidentGroup-manager",
    //       permissionCode: "Rule.IncidentGroupManager",
    //     }
    //   ],
    // },
    {
      name: i('站点管理'),
      icon: 'shop',
      path: '/site',
      permissionCode: 'SiteManager',
      children: [
        {
          name: i('站点列表'),
          path: '/list',
          permissionCode: 'SiteManager.List',
        },
        {
          name: i('站点下发记录'),
          path: '/down',
          permissionCode: 'SiteManager.DownHistory',
        },
      ],
    },
    {
      name: i('梯控管理'),
      icon: 'control',
      path: '/elevator',
      permissionCode: 'ElevatorManager',
      children: [
        // {
        //   name: i('梯控板管理'),
        //   path: '/controlBoard',
        //   permissionCode: 'ElevatorManager.EcbManagement',
        // },
        {
          name: i('电梯管理'),
          path: '/manager',
          permissionCode: 'ElevatorManager.ElevatorManagement',
        },
        {
          name: i('云电梯厂商管理'),
          path: '/cloudElevator',
          permissionCode: 'ElevatorManager.CloudElevatorManufacturerManagement',
        },
        {
          name: i('电梯运行记录'),
          path: '/runtimeRecord',
          permissionCode: 'ElevatorManager.ElevatorTaskRecord',
        },
        {
          name: i('电梯数据'),
          path: '/management',
          permissionCode: 'ElevatorManager.List',
        },
        // {
        //   name: i('梯控方案'),
        //   path: '/control',
        //   permissionCode: 'ElevatorManager.Solution.List',
        // },
        // {
        //   name: i('梯控OTA'),
        //   path: '/ota',
        //   permissionCode: 'ElevatorManager.BundleList',
        // },
      ],
    },
    {
      name: i('地图管理'),
      icon: 'file-markdown',
      path: '/map',
      permissionCode: 'MapManager',
      children: [
        {
          name: i('地图列表'),
          path: '/list',
          permissionCode: 'MapManager.List.Others',
        },
        {
          name: i('下发记录'),
          path: '/issued-record',
          permissionCode: 'MapManager.Transmission.List',
        },
        {
          name: i('编辑记录'),
          path: '/edit-record',
          permissionCode: 'MapManager.EditRecord',
        }
      ],
    },

    // {
    //   name: i('升级管理(内)'),
    //   icon: 'rise',
    //   path: '/upgrade',
    //   permissionCode: 'Upgrade',
    //   children: [
    //     {
    //       name: i('固件管理'),
    //       path: '/firmware-manager',
    //       permissionCode: 'Upgrade.FirmwareManager',
    //     },
    //     {
    //       name: i('机器人升级'),
    //       path: '/robot-upgrade',
    //       permissionCode: 'Upgrade.RobotUpgrade.List',
    //     },
    //     {
    //       name: i('固件推送计划'),
    //       path: '/firmware-push-plan',
    //       permissionCode: 'Upgrade.FirmwarePushPlan',
    //     },
    //     {
    //       name: i('升级历史'),
    //       path: '/upgrade-history',
    //       permissionCode: 'Upgrade.History',
    //     },
    //     {
    //       name: i('升级事件日志'),
    //       path: '/upgrade-log',
    //       permissionCode: 'Upgrade.Log',
    //     },
    //   ],
    // },
    // {
    //   name: i('升级服务'),
    //   icon: 'rise',
    //   path: '/upgrade-service',
    //   permissionCode: 'ExternalUpgradeService',
    //   children: [
    //     {
    //       name: i('机器人升级'),
    //       path: '/robot-upgrade-service',
    //       permissionCode: 'ExternalUpgradeService.RobotUpgrade',
    //     },
    //     {
    //       name: i('固件推送计划'),
    //       path: '/push-manager-service',
    //       permissionCode: 'ExternalUpgradeService.FirmwarePushPlan',
    //     },
    //   ],
    // },
    // {
    //   name: i('参数管理'),
    //   icon: 'reconciliation',
    //   path: '/argument',
    //   permissionCode: 'Argument',
    //   children: [
    //     {
    //       name: i('参数升级管理'),
    //       path: '/upgrade-management',
    //       permissionCode: 'Argument.UpgradeManagement',
    //     },
    //     {
    //       name: i('参数升级历史'),
    //       path: '/issue-history',
    //       permissionCode: 'Argument.IssueHistory',
    //     },
    //   ],
    // },
    // {
    //   name: i("数据平台"),
    //   icon: "dashboard",
    //   path: "/dataPlatform",
    //   permissionCode: "dataPlatform",
    //   children: [
    //     {
    //       name: i('核心备件看板'),
    //       path: '/coreSparePartBoard-Summary',
    //       permissionCode: 'dataPlatform.coreSparePartBoard-Summary',
    //     },
    //     {
    //       name: i('核心备件看板'),
    //       path: '/coreSparePartKanbanA',
    //       permissionCode: 'dataPlatform.coreSparePartKanbanA',
    //     },
    //     {
    //       name: i('核心备件看板'),
    //       path: '/coreSparePartKanbanB',
    //       permissionCode: 'dataPlatform.coreSparePartKanbanB',
    //     },
    //     {
    //       name: i('核心备件看板'),
    //       path: '/coreSparePartKanbanC',
    //       permissionCode: 'dataPlatform.coreSparePartKanbanC',
    //     },
    //     {
    //       name: i('核心备件看板'),
    //       path: '/coreSparePartKanbanX',
    //       permissionCode: 'dataPlatform.coreSparePartKanbanX',
    //     },
    //     {
    //       name: i('核心备件看板'),
    //       path: '/coreSparePartKanbanY',
    //       permissionCode: 'dataPlatform.coreSparePartKanbanY',
    //     },
    //     {
    //       name: i('核心备件看板'),
    //       path: '/coreSparePartKanbanZ',
    //       permissionCode: 'dataPlatform.coreSparePartKanbanZ',
    //     },
    //     {
    //       name: i('故障排查说明'),
    //       path: '/faultTroubleShooting-Chinese',
    //       permissionCode: 'dataPlatform.faultTroubleShooting-Chinese',
    //     },
    //     {
    //       name: i('故障排查说明'),
    //       path: '/faultTroubleShooting-English',
    //       permissionCode: 'dataPlatform.faultTroubleShooting-English',
    //     },
    //     {
    //       name: i('故障排查说明'),
    //       path: '/faultTroubleShooting-Japanese',
    //       permissionCode: 'dataPlatform.faultTroubleShooting-Japanese',
    //     },
    //     {
    //       name: i('故障排查说明'),
    //       path: '/faultTroubleShooting-Korean',
    //       permissionCode: 'dataPlatform.faultTroubleShooting-Korean',
    //     },
    //   ],
    // },
    // {
    //   name: i('机器信息管理'),
    //   icon: 'file-text',
    //   path: '/robot-info',
    //   permissionCode: 'RobotInfo',
    //   children: [
    //     {
    //       name: i('工具APP上报信息管理'),
    //       path: '/tool-app',
    //       permissionCode: 'RobotInfo.ToolApp',
    //     },
    //   ],
    // },
    // {
    //   name: i('机器部署'),
    //   icon: 'apartment',
    //   path: '/robotDeploy',
    //   permissionCode: 'Deploy',
    //   children: [
    //     {
    //       name: i('激光激活'),
    //       path: '/laserActive',
    //       permissionCode: 'Deploy.LaserActivation',
    //     },
    //   ],
    // },
    {
      name: i('系统管理'),
      icon: 'setting',
      permissionCode: 'System',
      path: '/system',
      children: [
        // {
        //   name: i('产品管理'),
        //   path: '/product',
        //   permissionCode: 'System.Product',
        // },
        {
          name: i('账号管理'),
          path: '/account',
          permissionCode: 'System.Account',
        },
        {
          name: i('权限管理'),
          path: '/permission',
          permissionCode: 'System.Permission',
        },
        // {
        //   name: i('固件管理'),
        //   path: '/firmware',
        //   permissionCode: 'System.Firmware',
        // },
      ],
    },
  ];
  console.log('isIOS', isIOS());
  return array;
}

const menuData = createMenuData();

export const getMenuData = () => {
  return formatter(menuData);
};
